import { cachedHttp } from "./httpService";

const apiEndPoint = "/timezones/";

function getTimeZones() {
  return cachedHttp.get(apiEndPoint);
}

export default getTimeZones;
